/**
 * Select Text Section JavaScript
 * Handles navigation and content display functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  initSelectTextSection();
});

function initSelectTextSection() {
  const sections = document.querySelectorAll('.select-text-section');
  
  sections.forEach(section => {
    const navItems = section.querySelectorAll('.nav-item');
    const navLinks = section.querySelectorAll('.nav-link');
    const contentBlocks = section.querySelectorAll('.content-block');
    const scrollMode = section.hasAttribute('data-scroll-mode');
    
    // Create mobile dropdown
    createMobileDropdown(section, navItems);
    
    // Add click event listeners to navigation items
    navItems.forEach((item, index) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('data-target');
        const targetContent = section.querySelector('#' + targetId);
        
        if (targetContent) {
          // Remove active class from all nav links
          navLinks.forEach(link => link.classList.remove('active'));
          
          // Add active class to clicked nav link
          const clickedLink = this.querySelector('.nav-link');
          if (clickedLink) {
            clickedLink.classList.add('active');
          }
      if (!scrollMode) {
            // Hide all content blocks with fade out
            contentBlocks.forEach(block => {
              block.classList.remove('active');
            });
            // Show target content with fade in
            setTimeout(() => {
              targetContent.classList.add('active');
              if (window.innerWidth <= 768) {
        scrollToTarget(targetContent);
              }
            }, 150);
          } else {
            // Scroll mode: ensure all blocks visible then smooth scroll
      scrollToTarget(targetContent);
          }
          
          // Analytics tracking (if available)
          if (typeof gtag !== 'undefined') {
            gtag('event', 'select_text_navigation', {
              'event_category': 'engagement',
              'event_label': clickedLink ? clickedLink.textContent.trim() : 'unknown'
            });
          }
        }
      });
      
      // Add keyboard navigation support
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
    
    // Add keyboard navigation for arrow keys
    navLinks.forEach((link, index) => {
      link.addEventListener('keydown', function(e) {
        let targetIndex = index;
        
        switch(e.key) {
          case 'ArrowDown':
            e.preventDefault();
            targetIndex = (index + 1) % navLinks.length;
            break;
          case 'ArrowUp':
            e.preventDefault();
            targetIndex = index === 0 ? navLinks.length - 1 : index - 1;
            break;
          case 'Home':
            e.preventDefault();
            targetIndex = 0;
            break;
          case 'End':
            e.preventDefault();
            targetIndex = navLinks.length - 1;
            break;
          default:
            return;
        }
        
        navLinks[targetIndex].focus();
      });
    });
      
    // Handle window resize for responsive behavior
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Reset any inline styles on resize
        navLinks.forEach(link => {
          if (!link.classList.contains('active')) {
            link.style.transform = '';
          }
        });
      }, 250);
    });
  });
}

// Create mobile dropdown navigation
function createMobileDropdown(section, navItems) {
  const textNavigation = section.querySelector('.text-navigation');
  const scrollMode = section.hasAttribute('data-scroll-mode');
  
  // Create dropdown container
  const dropdownContainer = document.createElement('div');
  dropdownContainer.className = 'mobile-dropdown';
  
  // Create select element
  const select = document.createElement('select');
  select.className = 'dropdown-select';
  select.setAttribute('aria-label', 'Select content section');
  
  // Add default option
  const defaultOption = document.createElement('option');
  defaultOption.value = '';
  defaultOption.textContent = 'Select a section...';
  defaultOption.disabled = true;
  defaultOption.selected = true;
  select.appendChild(defaultOption);
  
  // Create options from nav items
  navItems.forEach((item, index) => {
    const navLink = item.querySelector('.nav-link');
    const targetId = item.getAttribute('data-target');
    
    if (navLink && targetId) {
      const option = document.createElement('option');
      option.value = targetId;
      option.textContent = navLink.textContent.trim();
      
      // Set first option as selected if no active nav link
      if (index === 0 && !section.querySelector('.nav-link.active')) {
        option.selected = true;
        navLink.classList.add('active');
        const targetContent = section.querySelector('#' + targetId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      }
      
      select.appendChild(option);
    }
  });
  
  // Add change event listener
  select.addEventListener('change', function() {
    const selectedValue = this.value;
    if (selectedValue) {
      const targetContent = section.querySelector('#' + selectedValue);
      const allContentBlocks = section.querySelectorAll('.content-block');
      const allNavLinks = section.querySelectorAll('.nav-link');
      
      if (targetContent) {
        // Remove active class from all nav links
        allNavLinks.forEach(link => link.classList.remove('active'));
        // Add active class to corresponding nav link
        const correspondingNavItem = section.querySelector('[data-target="' + selectedValue + '"]');
        if (correspondingNavItem) {
          const correspondingNavLink = correspondingNavItem.querySelector('.nav-link');
          if (correspondingNavLink) {
            correspondingNavLink.classList.add('active');
          }
        }
        if (!scrollMode) {
          // Classic mode: hide others then show target
            allContentBlocks.forEach(block => block.classList.remove('active'));
            setTimeout(() => {
              targetContent.classList.add('active');
        scrollToTarget(targetContent);
            }, 150);
        } else {
          // Scroll mode: ensure all blocks visible (handled by CSS) then scroll
      scrollToTarget(targetContent);
        }
        
        // Analytics tracking
        if (typeof gtag !== 'undefined') {
          gtag('event', 'mobile_dropdown_navigation', {
            'event_category': 'engagement',
            'event_label': this.options[this.selectedIndex].textContent
          });
        }
      }
    }
  });
  
  // Add select to dropdown container
  dropdownContainer.appendChild(select);
  
  // Insert dropdown at the beginning of text navigation
  textNavigation.insertBefore(dropdownContainer, textNavigation.firstChild);
  
  // Update dropdown when desktop navigation is used
  const desktopNavItems = section.querySelectorAll('.nav-item');
  desktopNavItems.forEach(item => {
    item.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      if (targetId) {
        select.value = targetId;
      }
    });
  });
}

// Utility function to get active content
function getActiveContent(sectionId) {
  const section = document.querySelector('#select-text-' + sectionId);
  if (section) {
    const activeContent = section.querySelector('.content-block.active');
    return activeContent ? activeContent.id : null;
  }
  return null;
}

// Utility function to set active content programmatically
function setActiveContent(sectionId, contentId) {
  const section = document.querySelector('#select-text-' + sectionId);
  if (section) {
    const targetItem = section.querySelector('[data-target="' + contentId + '"]');
    if (targetItem) {
      targetItem.click();
      return true;
    }
  }
  return false;
}

// Export functions for external use
window.SelectTextSection = {
  getActiveContent: getActiveContent,
  setActiveContent: setActiveContent,
  init: initSelectTextSection
};

// Scroll helper (accounts for fixed header ~80px). Adjust if needed.
function scrollToTarget(el) {
  if (!el) return;
  const HEADER_OFFSET = 80; // ajustar si tu header es diferente
  const rect = el.getBoundingClientRect();
  const absoluteY = window.pageYOffset + rect.top - HEADER_OFFSET;
  window.scrollTo({ top: absoluteY < 0 ? 0 : absoluteY, behavior: 'smooth' });
}
